// extracted by mini-css-extract-plugin
export var copyableField = "_m2-4";
export var customerBadge = "_m2-0";
export var customerInfoTitle = "_m2-2";
export var details = "_m2-1";
export var dropdownContainer = "_m2-5";
export var dropdownImage = "_m2-6";
export var editAssigneeForm = "_m2-a";
export var editButton = "_m2-3";
export var email = "_m2-7";
export var hidden = "_m2-d";
export var input = "_m2-8";
export var saveButton = "_m2-b";
export var shopifyIcon = "_m2-c";
export var suggestionBadge = "_m2-e";
export var suggestionText = "_m2-f";
export var username = "_m2-9";